import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import CoreFeaturedCallout from 'ecosystem-marketplace-core/components/callouts/FeaturedCallout';
import ValidI18nMessage from 'ecosystem-marketplace-core/i18n/components/ValidI18nMessage';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import { useIsMaxScreenSize } from 'ecosystem-marketplace-core/hooks/useScreenSize';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'ecosystem-marketplace-core/constants/FeaturedCallouts';
import StorefrontUsageTrackerContext from '../../../context/StorefrontUsageTrackerContext';
import { selectCollections } from '../../../slices/collections/collectionsSlice';
import { fetchCallouts, selectCallouts } from '../../../slices/callouts/calloutsSlice';

function FeaturedCallout({
  callout,
  layout
}) {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const {
    id,
    publishedListing
  } = callout;
  const {
    collectionId,
    externalUrl
  } = publishedListing;
  const collections = useSelector(selectCollections);
  const collection = collections.find(c => c.id === collectionId);
  const LinkComponent = collection ? UIRouterLink : UILink;
  const link = collection ? collection.publishedListing.slug : externalUrl;
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.buttonText,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.buttonText`
    }),
    description: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.description,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.description`
    }),
    headline: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.headline,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.headline`
    }),
    gradientColor: publishedListing.gradientColor,
    illustrationName: publishedListing.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: collection ? {
      to: link
    } : {
      href: link
    },
    onClick: () => {
      trackInteraction('click featured callout', {
        section: `featured-callout::${id}::static`
      });
    },
    external: !collection,
    responsive: true
  });
}

function CalloutsSection({
  className
}) {
  const dispatch = useDispatch();
  const callouts = useSelector(selectCallouts);
  const isMobile = useIsMaxScreenSize(ScreenSizes.SM);
  useEffect(() => {
    dispatch(fetchCallouts());
  }, [dispatch]);
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: className,
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout
    }, callout.id))
  });
}

export default CalloutsSection;